import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MustMatch, UserService } from '../../../../public-api';
import { AbstractComponent } from '../../../commons/abstract.component';

@Component({
    templateUrl: 'reset-password.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResetPasswordComponent extends AbstractComponent {
  hideAllPasswords: boolean = false;

  hide: boolean = true;
  userId: string;

  constructor(
    injector: Injector,
    private userService: UserService,
    private dialogRef: MatDialogRef<ResetPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userId: string },
  ) {
    super(injector);
    this.setupForm();
    this.userId = data.userId;
  }


  setupForm(): void {
    this.formGroup = this.formBuilder.group(
      {
        newPassword: ['', [Validators.required, Validators.minLength(6)]],
        confirmedNewPassword: [
          '',
          [Validators.required, Validators.minLength(6)],
        ],
      },
      { validators: [MustMatch('newPassword', 'confirmedNewPassword')] },
    )
  }

  save(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched()
      return;
    }
    const { newPassword, confirmedNewPassword } = this.formGroup.value;

    if (!this.userId) {
      return;
    }
    this.loading = true;
    this.userService
      .resetPassword(this.userId, {
        newPassword,
        confirmedNewPassword: confirmedNewPassword,
      })
      .subscribe({
      next: () => {
        this.alertService.success(this.t('shared.resetPasswordLib.passwordUpdatedSuccess'));
        this.dialogRef.close(true);
        this.loading = false;
      },
      error: err => {
        this.alertService.error(err.error.message || this.t('shared.resetPasswordLib.passwordUpdateError'));
        this.loading = false;
      }
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
